import {
    REPORT_CONFIG_GET_REQUEST,
    REPORT_CONFIG_GET_SUCCESS,
    REPORT_CONFIG_GET_FAIL,
    REPORT_CONFIG_UPDATE_REQUEST,
    REPORT_CONFIG_UPDATE_SUCCESS,
    REPORT_CONFIG_UPDATE_FAIL,
    REPORT_CONFIG_UPDATE_RESET,
  } from '../constants/reportConstants';
  
  export const reportConfigGetReducer = (state = {}, action) => {
    switch (action.type) {
      case REPORT_CONFIG_GET_REQUEST:
        return { loading: true };
      case REPORT_CONFIG_GET_SUCCESS:
        return { loading: false, config: action.payload };
      case REPORT_CONFIG_GET_FAIL:
        return { loading: false, error: action.payload };
      default:
        return state;
    }
  };
  
  export const reportConfigUpdateReducer = (state = {}, action) => {
    switch (action.type) {
      case REPORT_CONFIG_UPDATE_REQUEST:
        return { loading: true };
      case REPORT_CONFIG_UPDATE_SUCCESS:
        return { loading: false, success: true, config: action.payload };
      case REPORT_CONFIG_UPDATE_FAIL:
        return { loading: false, error: action.payload };
      case REPORT_CONFIG_UPDATE_RESET:
        return {};
      default:
        return state;
    }
  }; 